import React from 'react';

export const ReminderSetIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 1C7.58172 1 4 4.58172 4 9V17H2V19H22V17H20V9C20 4.58172 16.4183 1 12 1ZM18 17V9C18 5.68629 15.3137 3 12 3C8.68629 3 6 5.68629 6 9V17H18Z"
        fill="#261B36"
      />
      <path d="M12 23C13.6569 23 15 21.6569 15 20H9C9 21.6569 10.3431 23 12 23Z" fill="#261B36" />
    </svg>
  );
};
